import { deleteCookie } from "globalservices/cookie";
import { getQueryStringKeys } from "globalutils/fmUtils";

export const getRedirectionURL = (search, key) => getQueryStringKeys(search, key);

export const handleLoginWithToken = (history, fetchLogin, clearRedux, COOKIE_AUTH_DETAILS) => {
    const token = getQueryStringKeys(history.location.state.search, 'token');
    const isNauto = window.$environment.SERVICE_PROVIDER === 'nauto';
    if (!token) return;

    const data = {
        token: token,
        ...(isNauto && {
            "company-id": getQueryStringKeys(history.location.state.search, 'company-id'),
            "group-id": getQueryStringKeys(history.location.state.search, 'group-id'),
            "callback-url": getQueryStringKeys(history.location.state.search, 'callback-url'),
        }),
    };
    deleteCookie(COOKIE_AUTH_DETAILS);
    clearRedux();
    fetchLogin({
        apiId: 'handleLogin',
        data,
        callback: (type, message) => {
            if (type === 'mfaEnabled') {
                history.push('/user/mfa');
            } else if (type === 'error' && message === 'permission denied') {
                history.push({
                    pathname: history.location.state?.referrer,
                    search: history.location.state?.search,
                    state: { error: 'permission denied' },
                });
            } else {
                history.push(
                    window.$environment.CURRENT_LAYOUT === 'SpireonNew'
                        ? history.location.state?.referrer
                        : '/'
                );
            }
        },
    });
};